export function excludeOverlappingContinuationSegments<T extends { street_segment_id: string }>(
  segments: T[],
  pathSegments: Array<{ street_segment_id: string }> | null | undefined,
  originalTail?: Array<{ street_segment_id: string }> | null | undefined
): T[] {
  const excludeIds = new Set<string>()
  for (const s of pathSegments ?? []) {
    excludeIds.add(s.street_segment_id)
  }
  for (const s of originalTail ?? []) {
    excludeIds.add(s.street_segment_id)
  }
  if (excludeIds.size === 0) return segments
  return segments.filter(s => !excludeIds.has(s.street_segment_id))
}
